"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChildrenGroup = exports.TreeGroup = void 0;
var starrytheme_1 = require("@starrez/starrytheme");
var styled_components_1 = require("styled-components");
var Theme_1 = require("../../../Theme");
var gap = Theme_1.PixelUnit(2);
/** Parent group for the entire tree */
exports.TreeGroup = styled_components_1.default.ul(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-size: ", ";\n    padding: 0;\n    margin: 0;\n    user-select: none;\n\n    > li:last-of-type {\n        margin-bottom: ", ";\n    }\n\n    ", "\n"], ["\n    font-size: ",
    ";\n    padding: 0;\n    margin: 0;\n    user-select: none;\n\n    > li:last-of-type {\n        margin-bottom: ", ";\n    }\n\n    ",
    "\n"])), function (props) { return props.FontSize ?
    (typeof (props.FontSize) === "number" ?
        props.FontSize + "px" : "" + props.FontSize)
    : "12px"; }, gap, function (props) { return props.FullWidthFocusStyling && "\n        display: flex;\n        flex-direction: column;\n        flex-grow: 1;\n    "; });
/** All subsequent children group */
exports.ChildrenGroup = styled_components_1.default.ul(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin: 0;\n    padding: 0;\n    margin-left: ", ";\n    > li:last-of-type {\n        margin-bottom: ", ";\n    }\n"], ["\n    margin: 0;\n    padding: 0;\n    margin-left: ",
    ";\n    > li:last-of-type {\n        margin-bottom: ",
    ";\n    }\n"])), function (props) { return props.IndentAmount ?
    (typeof (props.IndentAmount) === "number" ?
        props.IndentAmount + "px" : "" + props.IndentAmount)
    : "" + Theme_1.PixelUnit(1); }, function (props) { return props.SpaceAfterGroup
    ? "" + starrytheme_1.size[props.SpaceAfterGroup]
    : "" + gap; });
exports.ChildrenGroup.displayName = "Children";
var templateObject_1, templateObject_2;
